export default {
  UPDATE_NEW_TOKEN: "UPDATE_NEW_TOKEN",
};
